import * as React from 'react'
import { useSelector } from 'react-redux'
import { selectAllDraftLeads } from '@user/store/draftLeads'
import { DraftLeadListProviderProps } from './typings'
import { DraftLeadListView } from './DraftLeadListView'
import { useGetColumnData } from './useGetColumnData'
import { pageSizeOptions } from '@user/components/xGrid'

export const DraftLeadListProvider: React.FC<DraftLeadListProviderProps> = (
  props,
) => {
  const { loading: rowsLoading, page, perPage, ...rest } = props
  const rows = useSelector(selectAllDraftLeads)
  const { columns, colsLoading, columnVisibility } = useGetColumnData()

  const safePageSize = React.useMemo(() => {
    if (pageSizeOptions.includes(perPage)) {
      return perPage
    }
    return pageSizeOptions[0]
  }, [perPage])

  return (
    <DraftLeadListView
      {...rest}
      page={colsLoading ? 1 : page}
      columnVisibility={columnVisibility}
      loading={rowsLoading || colsLoading}
      rows={colsLoading ? [] : rows}
      columns={colsLoading ? [] : columns}
      perPage={safePageSize}
    />
  )
}
